<template>
  <v-footer padless class="my-background">
    <v-col :cols="12" :sm="12" :md="12" :lg="12" align="center">

      <v-row justify="center">
        <v-col :cols="4" :sm="4" :md="4" :lg="4">
          <h6 class="orange--text text">
            <span><v-icon class="orange--text">mdi-calendar</v-icon></span> De Lunes a Viernes desde
            las 8:00 hrs. a 17:30 hrs.
          </h6>
        </v-col>
        <v-col class="orange--text mt-5" :cols="4" :sm="4" :md="4" :lg="4"> &copy; {{ new Date().getFullYear() }} -
          <strong>Loginsa</strong></v-col>
        <v-col :cols="4" :sm="4" :md="4" :lg="4">
          <h6 class="orange--text text">
            <span><v-icon class="orange--text">mdi-map</v-icon></span> Av. José Miguel Infante Sur
            8725, Renca, Santiago – Chile
          </h6>
        </v-col>
      </v-row>
    </v-col>
  </v-footer>
</template>
<script>
export default {
  data: () => ({
    icons: [
      {
        text: "mdi-instagram",
        link: "",
      },
      {
        text: "mdi-twitter",
        link: "https://twitter.com/loginsachile",
      },
      {
        text: "mdi-web",
        link: "http://www.loginsa.com/",
      },
    ],
  }),
};
</script>
